<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-限时秒杀-秒杀活动-基础设置
  -->
  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item
      label="商家名称"
      prop="name"
      :rules="[{ required: true, message: '请输入商家名称', trigger: 'blur' }]"
    >
      <el-input
        v-model="form.name"
        placeholder="请输入商家名称"
        class="max-w460"
      ></el-input>
    </el-form-item>

    <el-form-item
      label="联系方式"
      prop="name"
      :rules="[{ required: true, message: '请输入联系方式', trigger: 'blur' }]"
    >
      <el-input
        v-model="form.mobile"
        placeholder="请输入联系方式"
        class="max-w460"
      ></el-input>
    </el-form-item>
    <!-- <el-form-item label="商家评级（1～5）" >
      <el-input v-model="form.grade" placeholder="商家评级（1～5）" class="max-w460"></el-input>
    </el-form-item> -->

    <el-form-item label="营业时间（09:00-18:00）">
      <el-input
        v-model="form.shop_hours"
        placeholder="营业时间（09:00-18:00）"
        class="max-w460"
      ></el-input>
    </el-form-item>

    <el-form-item label="虚拟关注数量">
      <el-input
        type="number"
        v-model="form.virfollow"
        placeholder="请输入数量"
        class="max-w460"
      ></el-input>
       <div class="mt10 tips">提示：虚拟关注默认10人</div>
    </el-form-item>

    <!-- <el-form-item label="商家等级">
        <el-select v-model="form.kmd_grade_id" placeholder="-请选择等级-">
           <el-option v-for="item in gradeList" :value="item.kmd_grade_id" :key="item.kmd_grade_id" :label="item.name" ></el-option>
        </el-select>
      </el-form-item> -->
    <el-form-item label="商家logo">
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="openUpload"
          >选择图片</el-button
        >
        <div v-if="form.file_path" class="img">
          <img :src="form.file_path" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>

    <el-form-item label="营业执照" prop="business_license">
      <el-row>
        <el-button
          icon="el-icon-picture-outline"
          @click="openUploadBusinessLicense"
          >选择图片</el-button
        >
        <div
          v-if="form.business_license && form.business_license.length > 0"
          class="img-list"
        >
          <div
            v-for="(img, index) in form.business_license"
            :key="index"
            class="img-item pr"
          >
            <img :src="img.file_path || img" width="100" height="100" />
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deleteBusinessLicense(index)"
            >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
      </el-row>
      <div class="mt10">最多可上传5张营业执照</div>
    </el-form-item>

    <el-form-item label="所属行业分类：" prop="category_id">
      <el-select v-model="form.category_id">
        <template v-for="cat in category">
          <el-option
            :value="cat.category_id"
            :key="cat.category_id"
            :label="cat.name"
          ></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option
              :value="two.category_id"
              :key="two.category_id"
              :label="two.name"
              style="padding-left: 30px;"
            ></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option
                :value="three.category_id"
                :key="three.category_id"
                :label="three.name"
                style="padding-left: 60px;"
              ></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>


    <!-- 商家类型 -->
    <el-form-item label="商家类型" prop="manufacturer_type">

      <el-radio-group v-model="form.manufacturer_type">

        <el-radio :label="1">
          生产商
        </el-radio>

        <el-radio :label="2">
          贸易商
        </el-radio>

      </el-radio-group>

    </el-form-item>

    <el-form-item
      label="展示图片"
      prop="pd_img"
    
    >
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="openUploadPdImg"
          >选择图片</el-button
        >
        <div v-if="form.pd_img && form.pd_img.length > 0" class="img-list">
          <div
            v-for="(img, index) in form.pd_img"
            :key="index"
            class="img-item pr"
          >
            <img :src="img.file_path || img" width="100" height="100" />
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deletePdImg(index)"
            >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
      </el-row>
     
    </el-form-item>

    <el-form-item label="详细地址" prop="address">
      <el-input
        v-model="form.address"
        placeholder="请输入详细地址"
        class="max-w460"
      ></el-input>
    </el-form-item>
    <el-form-item label="坐标">
      <el-row class="mb16">
        <el-col :span="24">
          <el-input v-model="form.coordinate" class="max-w460"></el-input>
        </el-col>
      </el-row>
      <el-row class="mb16">
        <el-col :span="24">
          <Getpoint
            :form="form"
            @getMapdata="getMapdataFunc"
            @chose="choseFunc"
          ></Getpoint>
        </el-col>
      </el-row>
    </el-form-item>

    <!-- <el-form-item label="禁止下单购买" prop="is_forbidden_buy" >
         <el-radio-group v-model="form.is_forbidden_buy">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item> -->

    <!-- <el-form-item label="禁止下单购买提示图片" prop="wxqrcode" v-if="form.is_forbidden_buy==1" >
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUploads({'type':'erweima'})">选择图片</el-button>
          <div v-if="form.wxqrcode!=''"  class="img pr">
            <img :src="form.wxqrcode" width="100" height="100" />
             <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('wxqrcode')"><i class="el-icon-close"></i></a>
          </div>
        </el-row>
      </el-form-item> -->

    <!-- <el-form-item label="视频封面图" prop="poster" >
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUploads({'type':'poster'})">选择图片</el-button>
          <div v-if="form.poster!=''" class="img pr">
            <img :src="form.poster" width="100" height="100" />
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('poster')"><i class="el-icon-close"></i></a>
          </div>
        </el-row>
      </el-form-item> -->

    <!-- <el-form-item label="视频" prop="video" >

          <el-input type="text"  v-model="form.video"  placeholder="请选择视频" class="max-w460">
            <template slot="append">
             <el-button icon="el-icon-picture-outline" @click="openUploads({'type':'video'})">选择视频</el-button>
            </template>
          </el-input>
      </el-form-item> -->

    <el-form-item label="商家简介">
      <el-input
        type="textarea"
        v-model="form.introduce"
        placeholder="请输入简介"
        class="max-w460"
      ></el-input>
    </el-form-item>
    <el-form-item label="备注">
      <el-input
        type="textarea"
        v-model="form.remark"
        placeholder="请输入备注"
        class="max-w460"
      ></el-input>
    </el-form-item>
    <!-- 20201201供应商商品展示模式 -->
    <!-- <el-form-item label="商品展示">
        <el-radio-group v-model="form.product_show">
            <el-radio :label="'one_column'">单列</el-radio>
            <el-radio :label="'two_column'">两列</el-radio>
            <el-radio :label="'video_scale'">16:9</el-radio>
            <el-radio :label="'category'">分类</el-radio>
        </el-radio-group>
      </el-form-item> -->
    <!-- <div class="common-form">积分抵扣设置</div> -->

    <!-- <el-form-item label="是否积分抵扣">
      <el-switch
        v-model="form.points_deduction_enable"
        :active-value="1"
        :inactive-value="0"
        active-text="开启"
        inactive-text="关闭"
        @change="handlePointsDeductionChange">
      </el-switch>
    </el-form-item> -->
<!-- 
    <el-form-item
      label="抵扣金额"
      prop="points_deduction_amount"
      v-if="form.points_deduction_enable === 1"
      :rules="[{ required: form.points_deduction_enable === 1, message: '请输入抵扣金额', trigger: 'blur' }, { validator: validatePointsAmount, trigger: 'blur' }]">
      <el-input
        v-model="form.points_deduction_amount"
        placeholder="请输入积分抵扣金额比例"
        class="max-w460"
        type="number"
        min="0">
        <template slot="append">%</template>
      </el-input>
    </el-form-item> -->



       <div class="common-form">发货地址设置</div>
  



      <el-form-item label="发货联系人" prop="msg">
        <el-input v-model="form.fh_name" placeholder="发货联系人" class="max-w460"></el-input>
      </el-form-item>

         <el-form-item label="发货手机号" prop="msg">
        <el-input v-model="form.fh_phone" placeholder="发货手机号" class="max-w460"></el-input>
      </el-form-item>

              <el-form-item label="发货地址" prop="msg">
        <el-input v-model="form.fh_address" placeholder="发货地址" class="max-w460"></el-input>
      </el-form-item>


      <div class="common-form">支付设置</div>
<!-- 
      <el-form-item label="是否开启支付">
        <el-radio-group v-model="form.is_pay">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item> -->

      <!-- <el-form-item label="商户名称">
          <el-input type='textarea' v-model="form.mch_name"
           placeholder="请输入商户名称" class="max-w460"></el-input>

        </el-form-item>

     <el-form-item label="微信商户号">
          <el-input type='textarea' v-model="form.mchid"
           placeholder="请输入微信商户号" class="max-w460"></el-input>

        </el-form-item>

       <el-form-item label="微信密钥">
          <el-input type='textarea' v-model="form.apikey"
           placeholder="请输入微信密钥" class="max-w460"></el-input>

        </el-form-item> -->


        <el-form-item label="公司名称">
          <el-input
              v-model="form.company"
              placeholder="请输入公司名称"
              class="max-w460">
          </el-input>
      </el-form-item>

      <el-form-item label="收款账户名">
          <el-input
              v-model="form.account"
              placeholder="请输入收款账户名"
              class="max-w460">
          </el-input>
      </el-form-item>

      <el-form-item label="开户银行">
          <el-input
              v-model="form.bank"
              placeholder="请输入开户银行"
              class="max-w460">
          </el-input>
      </el-form-item>

    <!--         
            <div class="common-form">分账设置</div>
          <el-form-item label="是否开启分账">
          <el-radio-group v-model="form.is_fz_open">
            <el-radio :label="0">关</el-radio>
            <el-radio :label="1">开</el-radio>
          </el-radio-group>
      </el-form-item>

           <el-form-item label="订单分账比例" prop="msg">
        <el-input v-model="form.fz_price" placeholder="订单分账比例/%" class="max-w460"></el-input>%
      </el-form-item>

         <el-form-item label="分账对象（手机号）" prop="msg">
        <el-input v-model="form.fz_phone" placeholder="分账对象（手机号）" class="max-w460"></el-input>
      </el-form-item>
 -->

    <!-- <div class="common-form">通知设置</div>
     <el-form-item label="绑定通知手机号">
          <el-input type='textarea' v-model="form.notice"
           placeholder="请输入通知手机号" class="max-w460"></el-input>
          <div>可多个，逗号隔开</div>
        </el-form-item> -->

    <div class="common-form">登陆信息</div>
    <el-form-item label="绑定用户">
      <div class="d-s-s d-c">
        <el-button @click="openGetuser" icon="el-icon-plus">选择会员</el-button>
        <div class="d-s-s" v-if="form.user">
          <img
            :src="form.user.avatarUrl"
            class="radius"
            width="30"
            height="30"
          />
        </div>
        <div class="d-s-s" v-if="form.user">
          <p class="lh18 ww100 text-ellipsis">
            用户昵称：{{ form.user.nickName }}
          </p>
        </div>
        <div class="d-s-s" v-if="form.user">
          <p class="lh18 ww100 text-ellipsis">手机号：{{ form.user.mobile }}</p>
        </div>
      </div>
      <span>绑定完成后，登陆后台只跟该用户有关</span>
    </el-form-item>
    <!-- <el-form-item label="后台账号" prop="user_name" :rules="[{required: true,message: ' '}]">
        <el-input type='mobile' v-model="form.user_name" v-if="!is_edit" placeholder="请输入手机号" class="max-w460"></el-input>
        <el-input type='mobile' v-model="form.user_name" v-if="is_edit" readonly placeholder="请输入手机号" class="max-w460"></el-input>
        @{{app_id}}
      </el-form-item>
      <el-form-item label="后台密码" prop="password" >
        <el-input v-model="form.password" placeholder="请输入密码(默认123456)" class="max-w460"></el-input>
      </el-form-item> -->

    <el-form-item label="商家状态">
      <el-radio-group v-model="form.status">
        <el-radio :label="1">启用</el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- <el-form-item label="商家类型">
        <el-radio-group v-model="form.self_manage">
          <el-radio :label="1">自营</el-radio>
          <el-radio :label="0">非自营</el-radio>
        </el-radio-group>
      </el-form-item> -->
    <el-form-item label="排序">
      <el-input
        type="number"
        v-model="form.sort"
        placeholder="请输入排序"
        class="max-w460"
      ></el-input>
    </el-form-item>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc"
      >上传图片</Upload
    >
    <!--上传营业执照图片组件-->
    <Upload
      v-if="isBusinessLicenseUpload"
      :isupload="isBusinessLicenseUpload"
      type="image"
      @returnImgs="returnBusinessLicenseFunc"
      >上传营业执照</Upload
    >
    <!--上传产品封面图片组件-->
    <Upload
      v-if="isPdImgUpload"
      :isupload="isPdImgUpload"
      type="image"
      @returnImgs="returnPdImgFunc"
      >上传产品封面</Upload
    >
    <!--上传图片组件-->
    <Upload
      v-if="uploadtype == 'erweima'"
      :isupload="isOtherUpload"
      type="image"
      @returnImgs="returnErweimaFunc"
      >上传二维码</Upload
    >
    <!--上传图片组件-->
    <Upload
      v-if="uploadtype == 'poster'"
      :isupload="isOtherUpload"
      type="image"
      @returnImgs="returnPosterFunc"
      >上传视频封面</Upload
    >

    <!--上传视频组件-->
    <Upload
      v-if="uploadtype == 'video'"
      :isupload="isOtherUpload"
      type="video"
      @returnImgs="returnVideosFunc"
      >上传视频</Upload
    >
    <!--选择用户-->
    <GetUser :is_open="open_getuser" @close="closeGetuserFunc"></GetUser>
  </div>
</template>

<script>
import Getpoint from "@/components/map/Getpoint.vue";
import Upload from "@/components/file/Upload";
import GetUser from "@/components/user/GetUser.vue";
export default {
  components: {
    /*选择商品组件*/
    Upload,
    Getpoint,
    GetUser
  },
  data() {
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error("请上传活动图"));
      } else {
        callback();
      }
    };


    return {
      /*获取用户是否显示*/
      open_getuser: false,
      /*选择的用户列表*/
      select_user: {},
      /* 上传类型 */
      uploadtype: "",
      /* 是否打开其他上传 */
      isOtherUpload: false,
      isPdImgUpload: false,
      /* 营业执照上传 */
      isBusinessLicenseUpload: false,
      /* 最大上传数量 */
      maxPdImgCount: 12,
      /* 最小上传数量 */
      minPdImgCount: 9,
      /* 营业执照最大上传数量 */
      maxBusinessLicenseCount: 9,
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否上传图片*/
      isupload: false,
      /*图片是否上传了*/
      rulesImage: [
        {
          validator: validatorImages,
          required: true,
          message: "请上传logo",
          trigger: "change"
        }
      ]
    };
  },
  props: {
    form: Object,
    gradeList: Array,
    app_id: Number,
    is_edit: Boolean,
    category: Array
  },
  methods: {
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /* 打开营业执照上传 */
    openUploadBusinessLicense() {
      // 检查当前已上传数量
      const currentCount = this.form.business_license
        ? this.form.business_license.length
        : 0;
      if (currentCount >= this.maxBusinessLicenseCount) {
        this.$message.warning(
          `最多只能上传${this.maxBusinessLicenseCount}张营业执照`
        );
        return;
      }
      this.isBusinessLicenseUpload = true;
    },
    /* 获取营业执照 */
    returnBusinessLicenseFunc(e) {
      if (e != null && e.length > 0) {
        // 初始化business_license数组
        if (!this.form.business_license) {
          this.form.business_license = [];
        }

        // 计算还能上传多少张
        const currentCount = this.form.business_license.length;
        const canAddCount = this.maxBusinessLicenseCount - currentCount;
        const addCount = Math.min(e.length, canAddCount);

        // 添加新图片
        for (let i = 0; i < addCount; i++) {
          this.form.business_license.push({
            file_path: e[i].file_path,
            file_id: e[i].file_id
          });
        }

        // 如果还有没添加的图片，提示用户
        if (e.length > addCount) {
          this.$message.warning(
            `只能再添加${canAddCount}张营业执照，多余的已忽略`
          );
        }
      }
      this.isBusinessLicenseUpload = false;
    },
    /* 打开产品封面上传 */
    openUploadPdImg() {
 
      this.isPdImgUpload = true;
    },
    /* 获取产品封面 */
    returnPdImgFunc(e) {
      if (e != null && e.length > 0) {
        // 初始化pd_img数组
        if (!this.form.pd_img) {
          this.form.pd_img = [];
        }

        // 计算还能上传多少张
        const currentCount = this.form.pd_img.length;
        const canAddCount = this.maxPdImgCount - currentCount;
        const addCount = Math.min(e.length, canAddCount);

        // 添加新图片
        for (let i = 0; i < addCount; i++) {
          this.form.pd_img.push({
            file_path: e[i].file_path,
            file_id: e[i].file_id
          });
        }

        // 如果还有没添加的图片，提示用户
        if (e.length > addCount) {
          this.$message.warning(`只能再添加${canAddCount}张图片，多余的已忽略`);
        }
      }
      this.isPdImgUpload = false;
    },

    /*获取经纬度*/
    getMapdataFunc(e) {
      this.form.coordinate = e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },

    /*选择的地址*/
    choseFunc(e) {
      this.form.coordinate = e.location.lat + "," + e.location.lng;
      this.form.address = e.address;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
    },
    /*打开弹出层*/
    addClick() {
      this.open_add = true;
    },
    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      if (e.type != "error") {
        this.user_info = e.params[0];
        this.form.user_id = e.params[0].user_id;
      }
      this.open_add = false;
    },
    /* 打开上传 */
    openUploads(e) {
      this.uploadtype = e.type;
      this.isOtherUpload = true;
    },
    /* 获取二维码 */
    returnErweimaFunc(e) {
      if (e != null && e.length > 0) {
        this.form.wxqrcode = e[0].file_path;
      }
      this.isOtherUpload = false;
      this.uploadtype = "";
    },
    /* 获取视频封面 */
    returnPosterFunc(e) {
      if (e != null && e.length > 0) {
        this.form.poster = e[0].file_path;
      }
      this.isOtherUpload = false;
      this.uploadtype = "";
    },
    /* 获取视频 */
    returnVideosFunc(e) {
      if (e != null && e.length > 0) {
        this.form.video = e[0].file_path;
      }
      this.isOtherUpload = false;
      this.uploadtype = "";
    },
    /* 删除营业执照 */
    deleteBusinessLicense(index) {
      this.form.business_license.splice(index, 1);
    },
    /* 删除产品封面 */
    deletePdImg(index) {
      this.form.pd_img.splice(index, 1);
    },
    /* 删除图片 */
    deleteImg(type) {
      if (type == "poster") {
        this.form.poster = "";
      }
      if (type == "wxqrcode") {
        this.form.wxqrcode = "";
      }
    },
    /*打开获取用户*/
    openGetuser() {
      this.open_getuser = true;
    },

    /*关闭获取用户*/
    closeGetuserFunc(e) {
      if (e.type != "error") {
        this.form.user = e.params[0];
        this.form.user_id = e.params[0].user_id;
        this.form.user_name = this.form.user.mobile;
        this.form.password = 123456;
      }
      this.open_getuser = false;
    }
  }
};
</script>

<style lang="scss" scoped="scoped">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}
.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}

.img-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.img-item {
  width: 100px;
  height: 100px;
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
}

.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: rgba(255, 0, 0, 0.7);
  }
}

.business-license-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}
.tips {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  line-height: 1.4;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/part/Basic.vue